import { render } from "./SlideItem.vue?vue&type=template&id=7cfc969c&scoped=true&ts=true"
import script from "./SlideItem.vue?vue&type=script&lang=ts"
export * from "./SlideItem.vue?vue&type=script&lang=ts"

import "./SlideItem.vue?vue&type=style&index=0&id=7cfc969c&lang=scss&scoped=true"

import exportComponent from "/builds/root/dev.front.widget/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cfc969c"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import TouchPan from 'quasar/src/directives/touch-pan/TouchPan.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QBtn});qInstall(script, 'directives', {TouchPan});
